import React from 'react';
import { PageHeader, Tabs } from 'antd';

import CodeHighlight from 'code-highlight';

// import all the styles
import "code-highlight/lib/style.css";
import "highlight.js/styles/github-gist.css";

const { TabPane } = Tabs;
const routes = [
  {
    path: '/',
    breadcrumbName: 'Forms',
  },
  {
    path: 'CheckBoxs',
    breadcrumbName: 'CheckBoxs',
  },
];

const CheckBoxs = () => {
  return (
    <>

      <PageHeader title="CheckBox" breadcrumb={{ routes }} subTitle="CheckBox" style={{ padding: 10 }} />

      <div className="MF_area">
        <label className="checkbox_style">
          <input type="checkbox"/>
          Checkbox는 CSS로 작성됩니다.
            <span></span>
        </label>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<div class="checkbox_wrap">
  <input type="checkbox" id="checkbox" />
  <label for="checkbox">
    <div class="checkbox_style"><span></span></div>
    Checkbox는 이미지가 아닌 css로 작성됩니다.
  </label>
</div>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>

      <div className="MF_area">
        <label className="radio_style">
          <input type="radio" />
            RadioBox는 CSS로 작성됩니다.
            <span></span>
        </label>
        <label className="radio_style">
          <input type="radio" />
          RadioBox는 CSS로 작성됩니다.
          <span></span>
        </label>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<label className="radio_style">
  <input type="radio" />
    RadioBox는 CSS로 작성됩니다.
    <span></span>
</label>
<label className="radio_style">
  <input type="radio" />
    RadioBox는 CSS로 작성됩니다.
    <span></span>
</label>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>
    </>
  );
}

export default CheckBoxs;
